export default {
    // --------Title--------
    warehouseLocation: 'Warehouse Location',
    basicInformationForWarehouse: 'Basic information for warehouse',
    preciseLocationInformation: 'Precise location information',
    storages: 'Storages',
    defineForAvailableStorageSections: 'Define for available storage sections',
    segmentation: 'Segmentation',
    organizeLocationSections: 'Organize location sections',

    // --------Drawer--------
    newRack: 'New Rack',
    updateRack: 'Update Rack',
    normal: 'Normal',
    reserved: 'Reserved',
    rackName: 'Rack Name',
    sortNo: 'Sort No',
    newSlot: 'New Slot',
    updateSlot: 'Update Slot',
    slotName: 'Slot Name',
    sequence: 'Sequence',
    newZone: 'New Zone',
    updateZone: 'Update Zone',

    // --------MUI--------
    racks: 'Rack',
    zones: 'Zones',
    rack: 'Rack',
    worker: 'Worker',
    locationName: 'Location Name',
    personInChargeName: 'Person-In Charge Name',

};